import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { StringKey } from '../../../../lang/index';

export const WorkspaceSectionLabel: FC<{ title: StringKey }> = ({ title }) => (
  <p className="w-full text-[10px] font-semibold uppercase leading-4 tracking-[1px] text-gray-500">
    <AppFormattedMessage id={title} />
  </p>
);
